import { IS_PROD } from '../constants/env';

/**
 * The main configutaion to add new feature flags.
 *
 * @remarks
 * These flags should be used to toggle experimental or development features.
 */
export const defaultFeatureConfig = {
  /**
   * If enabled, the app will use the offline data for testing purposes
   * Do not enable this feature in production
   */
  offlineTesting: false,
  /**
   * If enabled, the app will use the dev UI
   * Do not enable this feature in production
   */
  isDevUiEnabled: !IS_PROD,
  serviceWorker: true,
  notificationDialog: false,
  isBlockrailTheme: false,
} as const;

export type FeatureConfigKey = keyof typeof defaultFeatureConfig;
